// Generated by ts-to-zod
import { z } from 'zod'

// NOTE: This schema had to be manually generated since ts-to-zod
// could not generate it automatically for some reason
export const jwtPayloadSchema = z.object({
  iss: z.string().optional(),
  sub: z.string().optional(),
  aud: z.union([z.string(), z.array(z.string())]).optional(),
  exp: z.number().optional(),
  nbf: z.number().optional(),
  iat: z.number().optional(),
  jti: z.string().optional()
})

export const postQualificationTokenPayloadSchema = jwtPayloadSchema.and(
  z.record(z.unknown()).and(
    z.object({
      journey_id: z.string(),
      initial_submission_id: z.string().optional(),
      nonce: z.string().optional()
    })
  )
)
